import { ReactComponent as TrainingCertification } from "../../../../assets/images/icons/traincertificate.svg";
import { ReactComponent as GetStarted } from "../../../../assets/images/icons/getstarted.svg";
import { ReactComponent as Documentation } from "../../../../assets/images/icons/documentation.svg";
import { ReactComponent as Blog } from "../../../../assets/images/icons/blog.svg";
import { ReactComponent as CaseStudies } from "../../../../assets/images/icons/casestudies.svg";
import { ReactComponent as PlatformOverview } from "../../../../assets/images/icons/platformoverview.svg";
import { ReactComponent as TrustCenter } from "../../../../assets/images/icons/trustcenter.svg";
import { ReactComponent as Webinars } from "../../../../assets/images/icons/webinars.svg";
import { ReactComponent as News } from "../../../../assets/images/icons/news.svg";

export const Learn1 = [
  {
    icon: <TrainingCertification />,
    title: "Training & Certifications",
    path: "/training",
  },
  {
    icon: <GetStarted />,
    title: "Getting Started",
    path: "/gettingstarted",
  },
  {
    icon: <Documentation />,
    title: "Documentation",
    path: "/documentation",
  },
];
export const Learn2 = [
  {
    icon: <Blog />,
    title: "Blog",
    path: "/blog",
  },
  {
    icon: <CaseStudies />,
    title: "Case Studies",
    path: "/casestudies",
  },
  {
    icon: <PlatformOverview />,
    title: "Platform Overview",
    path: "/platformoverview",
  },
];

export const Learn3 = [
  {
    icon: <TrustCenter />,
    title: "Trust Center",
    path: "/trustcenter",
  },
  {
    icon: <Webinars />,
    title: "Webinars",
    path: "/webinars",
  },
  {
    icon: <News />,
    title: "News",
    path: "/news",
  },
];
